import axios from 'axios'
import { axiosClient } from './AxiosClient'
import dayjs from 'dayjs'

const feature = {
    NEWS: "NEWS",
    CALENDAR: "CALENDAR",
    LANGUAGE: "LANGUAGE",
    SERVICE: "SERVICE",
    WIDGET: "WIDGET",
    USER: "USER",
    PERMISSION: "PERMISSION",
    TENANT: "TENANT",
    LINK: "LINK",
    BOOKING: "BOOKING",
    DELIVERY: "DELIVERY",
    VISITOR: "VISITOR"
}

function listBuilding(callback, errorCallback){
    let url = "/building/list"
    axiosClient.get(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createBuilding(buildingName, address, packageId, logo, callback, errorCallback){
    let url = "/building/create"

    var bodyForm = new FormData()
    bodyForm.append("building_name", buildingName)
    bodyForm.append("address", address)
    bodyForm.append("package_id", packageId)
    if(logo !== null){
        bodyForm.append("logo_file", logo)
    }

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeBuilding(buildingId, callback, errorCallback){
    let url = "/building/delete"
    var bodyForm = new FormData()
    bodyForm.append("building_id", buildingId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>errorCallback(error))
}

function viewBuilding(buildingId, callback, errorCallback){
    let url = "/building/view/" + buildingId

    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        let company = data.company
        let building = data.building
        let users = data.users
        callback(building, company, users)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function editBuilding(buildingId, buildingName, address, packageId, logo, callback, errorCallback){
    let url = "/building/edit"
    var bodyForm = new FormData()
    bodyForm.append("building_id", buildingId)
    bodyForm.append("building_name", buildingName)
    bodyForm.append("package_id", packageId)
    bodyForm.append("address", address)
    if(logo !== null){
        bodyForm.append("logo_file", logo)
    }

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listFeature(callback, errorCallback){
    let url = "/building/feature/list"

    axiosClient.get(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function setEnableFeature(featureId, isEnable, callback, errorCallback){
    let url = "/building/feature/setEnableFeature"
    var bodyForm = new FormData()
    bodyForm.append("feature_id", featureId)
    bodyForm.append("is_enable", isEnable)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listPackages(callback, errorCallback){
    let url = "/building/package/list"

    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function listPackageFeatureList(packageId, callback, errorCallback){
    let url = "/building/package/list_feature"
    let query = {
        package_id: packageId
    }
    axiosClient.get(url, {
        params: query
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function addFeatureToPackage(featureId, packageId, callback, errorCallback){
    let url = "/building/package/add_feature"
    var bodyForm = new FormData()
    bodyForm.append("feature_id", featureId)
    bodyForm.append("package_id", packageId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeFeatureFromPackage(featureId, packageId, callback, errorCallback){
    let url = "/building/package/remove_feature"
    var bodyForm = new FormData()
    bodyForm.append("feature_id", featureId)
    bodyForm.append("package_id", packageId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createPackage(packageName, packageDetail, limitUser, limitTenants, callback, errorCallback){
    let url = "/building/package/create"
    var bodyForm = new FormData()
    bodyForm.append("package_name", packageName)
    bodyForm.append("package_detail", packageDetail)
    bodyForm.append("limit_user", limitUser)
    bodyForm.append("limit_tenants", limitTenants)

    axiosClient.post(url, bodyForm)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function editPackage(packageId, packageName, packageDetail, limitUser, limitTenants, callback, errorCallback){
    let url = "/building/package/edit"
    var bodyForm = new FormData()
    bodyForm.append("package_id", packageId)
    bodyForm.append("package_name", packageName)
    bodyForm.append("package_detail", packageDetail)
    bodyForm.append("limit_user", limitUser)
    bodyForm.append("limit_tenants", limitTenants)

    axiosClient.post(url, bodyForm)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function removePackage(packageId, callback, errorCallback){
    let url = "/building/package/delete/" + packageId
    
    axiosClient.delete(url)
    .then((response) => {
        callback(response)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewPackage(packageId, callback, errorCallback){
    let url = "/building/package/view/" + packageId

    axiosClient.get(url)
    .then((response) => {
        let data = response.data
        let packagesInfo = data.package
        let features = data.feature
        callback(packagesInfo, features)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function adminDashboard(callback, errorCallback){
    let url = "/administration/dashboard"

    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function adminLog(startDate, endDate, type, callback, errorCallback){
    let url = "/administration/log"

    var queryLog = {}
    if(startDate !== null){
        queryLog["start_date"] = dayjs(startDate).format("MM/DD/YYYY HH:mm")
    }
    if(endDate !== null){
        queryLog["end_date"] = dayjs(endDate).format("MM/DD/YYYY HH:mm")
    }
    if(type !== ""){
        queryLog["type"] = type
    }

    axiosClient.get(url, {
        params: queryLog
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listuserSuperadmin(callback, errorCallback){
    let url = "/administration/user/list"
    axiosClient.get(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function toggleSuperadmin(userId, isSuperadmin, callback, errorCallback){
    let url = "/administration/user/superadmin/toggle"

    var bodyForm = new FormData()
    bodyForm.append("user_id", userId)
    bodyForm.append("is_super_admin", isSuperadmin)

    axiosClient.post(url, bodyForm)
    .then((response) => {
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listDepartmentByUser(userId, callback, errorCallback){
    const url = `/administration/user/department`
    const query = {
        user_id: userId
    }
    axiosClient.get(url,{
        params: query
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

export { 
    listBuilding, 
    createBuilding, 
    removeBuilding, 
    viewBuilding, 
    editBuilding, 
    listFeature, 
    setEnableFeature,
    feature,
    listPackages,
    listPackageFeatureList,
    addFeatureToPackage,
    removeFeatureFromPackage,
    createPackage,
    editPackage,
    viewPackage,
    removePackage,
    adminDashboard,
    adminLog,
    listuserSuperadmin,
    toggleSuperadmin,
    listDepartmentByUser
}